import { filterRegisterList } from "./filters/index";
import { ComponentConfigProps, FilterFieldKey } from "./typing";

export const filterComponents = new Map<
  FilterFieldKey,
  ComponentConfigProps | ComponentConfigProps[]
>();

const registerComponents = (
  key: FilterFieldKey,
  config: ComponentConfigProps | ComponentConfigProps[]
) => {
  if (filterComponents.get(key)) {
    throw new Error("cannot duplicate registration");
  }

  filterComponents.set(key, config);
};

const register = () => {
  registerComponents("all", filterRegisterList);
  for (const item of filterRegisterList) {
    registerComponents(item.key, item);
  }
};

register();
